update_free_shipping_progress_bar_widgets();

function update_free_shipping_progress_bar_widgets(){

    // update progress bars
    let free_shipping_progress_bar_widgets = document.getElementsByClassName("free-shipping-progress-bar-widget");

    if(free_shipping_progress_bar_widgets.length > 0){
        for (let widget of free_shipping_progress_bar_widgets) {
            let free_shipping_text = '';

            let cart_total = widget.dataset.cartTotal;
            let free_shipping_threshold = widget.dataset.freeThreshold;
            let expedited_shipping_threshold = widget.dataset.expressThreshold;

            let free_shipping_spend_required = free_shipping_threshold - cart_total;
            let expedited_shipping_spend_required = expedited_shipping_threshold - cart_total;

            let progress_bar_width = 0;

            // adjust free shipping progress bar
            if (
                free_shipping_spend_required > 0 && free_shipping_spend_required != free_shipping_threshold
            ){
                let progress_bar_percent = 100 / free_shipping_threshold;
                progress_bar_width = progress_bar_percent * cart_total;
            }

            // adjust free express shipping progress bar
            if (free_shipping_spend_required <= 0){
                
                progress_bar_width = 100;
                
                if (
                    expedited_shipping_threshold != 0 && (
                        expedited_shipping_spend_required > 0 && expedited_shipping_spend_required != expedited_shipping_threshold)
                ){
                    let progress_bar_percent = 100 / expedited_shipping_threshold;
                    progress_bar_width = progress_bar_percent * cart_total;
                }

            }

            // assemble free shipping text
            if( free_shipping_spend_required > 0 ){
                let free_shipping_spend_required_text = free_shipping_spend_required / 100;
                free_shipping_text = window.translations.spendForFreeStandardDelivery;
                free_shipping_text = free_shipping_text.replace("XAMOUNTX", convert_to_currency(free_shipping_spend_required_text));
            } else if(expedited_shipping_threshold != 0) {
                if (expedited_shipping_spend_required > 0){
                    let expedited_shipping_spend_required_text = expedited_shipping_spend_required / 100;
                    free_shipping_text = '<strong>' + window.translations.freeStandardDeliveryUnlocked + '</strong><br/>';
                    free_shipping_text_affix = window.translations.spendForFreeExpressDelivery;
                    free_shipping_text_affix = free_shipping_text_affix.replace("XAMOUNTX",convert_to_currency(expedited_shipping_spend_required_text));
                    free_shipping_text = free_shipping_text + free_shipping_text_affix;
                } else {
                    free_shipping_text = '<strong>' + window.translations.freeExpressDeliveryUnlocked + '</strong>';
                }
            } else {
                free_shipping_text = '<strong>' + window.translations.freeStandardDeliveryUnlocked + '</strong>';
            }

            progress_bar_width = progress_bar_width > 100 ? 100 : progress_bar_width;

            // set free shipping text
            widget.children[0].innerHTML = free_shipping_text;

            // set progress bar width
            widget.children[1].children[0].style.width = progress_bar_width + '%';

            // watch for changes in the data attributes (i.e. cart total amount) and update the cart widget when this happens
            const observer = new MutationObserver(update_free_shipping_progress_bar_widgets);
            observer.observe(widget, { attributes: true });
        }
    }

    // update delivery message for customers browsing in a different currency to the shop currency
    let free_shipping_progress_bar_widgets_diff_currency = document.getElementsByClassName("free-shipping-progress-bar-widget-diff-currency");

    if(free_shipping_progress_bar_widgets_diff_currency.length > 0){

        for (let widget of free_shipping_progress_bar_widgets_diff_currency) {

            let free_shipping_threshold = widget.dataset.freeThreshold - 1;
            let free_shipping_spend_required_text = (free_shipping_threshold / 100);

            let free_shipping_text = window.translations.freeStandardDelivery;
            free_shipping_text = free_shipping_text.replace("XAMOUNTX", convert_to_currency(free_shipping_spend_required_text));

            let expedited_shipping_threshold = widget.dataset.expressThreshold;
            if(expedited_shipping_threshold != 0) {
                expedited_shipping_threshold = expedited_shipping_threshold - 1;
                let expedited_shipping_spend_required_text = (expedited_shipping_threshold / 100);
                let free_shipping_text_affix = window.translations.freeExpressDelivery;
                free_shipping_text_affix = free_shipping_text_affix.replace("XAMOUNTX", convert_to_currency(expedited_shipping_spend_required_text));
                free_shipping_text += '<span>' + free_shipping_text_affix + '</span>';
            }

            widget.children[0].innerHTML = free_shipping_text;

        }

    }

}

function convert_to_currency(amount){
    // Check for UK (both D2C and B2B)
    if( document.body.classList.contains('uk') || document.body.classList.contains('ukb2b') ){
        amount = amount.toLocaleString('en-GB', {
            style: 'currency',
            currency: 'GBP'
        });
    }
    // Check for US (both D2C and B2B)
    if( document.body.classList.contains('us') || document.body.classList.contains('usb2b') ){
        amount = amount.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD'
        });
    }
    // Check for EU (both D2C and B2B)
    if( document.body.classList.contains('eu') || document.body.classList.contains('eub2b') ){
        amount = '€' + amount.toLocaleString('de-DE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }
    return amount;
}